import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csbreak(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Break tutorial For Beginners</title>
 <meta name="description" content="C# Break tutorial for beginners,When a c# break is encountered inside any loop, control automatically passes to the first statement after the loop,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Break,c# break for,c sharp break,c# break for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,break foreach c#,c# foreach break" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-break" />
 </Helmet>


 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Break Statement</h1>
    <div className="first">
        <a href="/csharp-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">1, C# break keyword is used to  exit from loop and switch<br/>
2, When a c# break is encountered inside any loop, control automatically passes to the first statement after the loop.<br/>
3, Break in c# break statement is used to terminate a loop immediately. The break statement  is encountered inside a loop<br/>
</p>



<h2 className="headings">The Syntax for C# Break:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5"> Break</span>
            <span className="qwerty-1">;</span>
            {"\n"}
           {"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">C# Break Example:</h2>


<h2 className="headings">Q-Write a program if i==5 so Break for Loop in C# Break Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-5">break</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-3">Program</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-2"> static</span>
            <span className="qwerty-1"> void </span>
            <span className="qwerty-4">main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-1">String</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-4">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5"> int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-4"> for </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-4">; </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2">&#60;</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">10</span>
            <span className="qwerty-5">; </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-6"> if </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-6"> == </span>
            <span className="qwerty-7">5</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-5"> break</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-4"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">1</span>
            {"\n"}
            <span className="qwerty-3">2</span>
            {"\n"}
            <span className="qwerty-2">3 </span>
            {"\n"}
            <span className="qwerty-7">4 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program Break on first even no in c# Break for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-5">break</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-3">Program</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-2"> static</span>
            <span className="qwerty-1"> void </span>
            <span className="qwerty-4">main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-5">String</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-4">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5"> int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-4"> for </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-4">; </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2">&#60;</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">10</span>
            <span className="qwerty-5">; </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-6"> if</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-1"> % </span>
            <span className="qwerty-7">2</span>
            <span className="qwerty-1"> == </span>
            <span className="qwerty-7">0</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-5"> break</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-4"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">1</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className="headings">Q-Write a program Break first even no in C# Break for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-5">break</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-3">Program</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-2"> static</span>
            <span className="qwerty-1"> void </span>
            <span className="qwerty-4">main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-1">String</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-4">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5"> int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-4"> for </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-4">; </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2">&#60;</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">5</span>
            <span className="qwerty-5">; </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-6"> if </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-6"> == </span>
            <span className="qwerty-7">4</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-5"> break</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-4"> Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-7">this is </span>
            <span className="qwerty-2">Break</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-2">+</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-2">Break </span>
            <span className="qwerty-6">Complete</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5">This is </span>
            <span className="qwerty-4">Break1</span>
            {"\n"}
            <span className="qwerty-5">This is </span>
            <span className="qwerty-3">Break2</span>
            {"\n"}
            <span className="qwerty-5">This is </span>
            <span className="qwerty-2">Break3 </span>
            {"\n"}
            <span className="qwerty-7">Break </span>
            <span className="qwerty-6">Complete </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/csharp-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csbreak;